<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <!-- <div>
        <el-button type="primary" size="mini" @click="impPrice" :disabled="!btn.batch">生成外协订单</el-button>
        <el-button type="primary" size="mini" @click="setInvalid" :disabled="!btn.batch">首道外协用料清单</el-button>
        </div> -->
        <div style="margin-top: 2px">
         <el-button @click.native.prevent="CreateOrder()" type="primary" size="mini">{{$t('getapi[6762]')}}</el-button>
        </div>
        <div id="xpane-0">
            <vTable
                    :data="dataSet"
                    :loading="loading"
                    queryData="ProToIssOrderPlanViewInfo"
                    :filter_thousandth="['PlanQty','Shipment_Cycle','onHandQty','listpart_qty','sum_qty','qty_on_hand','assist_qty_on_hand']"
                    :header="tableHeader"
                    :height="tableHeight - reduceTableHeight"
                    @handleSelectionChange="handleSelectionChange"
                    @handleSelectionChangeAll="handleSelectionChangeAll"
                    @handleSelectionChangeEnd="handleSelectionChange"
                    :row-class-name="tableRowClassName"
                    @LookDetail="LookDetail"
                    ref="singleTable"
            ></vTable>
            <!--<vxe-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                resizable
                size="mini"
                :height="tableHeight - reduceTableHeight"
                @checkbox-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                @sort-change="sortChange"
                :sort-config="{remote: true}"
                @checkbox-all="handleSelectionChangeAll"
                @checkbox-range-end="handleSelectionChange"
                :checkbox-config="{highlight: true, range: true}"
                :mouse-config="{selected:true, extension: true}"
                :header-cell-style="$limits.headerClass"
        >
            <vxe-table-column type="checkbox" width="40"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')" sortable width="150"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" sortable width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="part_name" :title="$t('getapi[116]')" sortable width="150"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="part_master_unit" :title="$t('getapi[888]')" sortable width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="Vender_Code" :title="$t('getapi[1196]')" sortable width="100">
                <template scope="scope">
                    <el-input
                            v-model="scope.row.Vender_Code"
                            type="text"
                            readonly
                            size="mini"
                    >
                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSupplier(scope)"></i>
                    </el-input>
                </template>    
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="PriorRoutingName" :title="$t('getapi[6763]')" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="IssRoutingName" :title="$t('getapi[6764]')" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="so_code" :title="$t('getapi[4916]')" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="PriorRouting_sequence_no" :title="$t('getapi[6765]')" align="right" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="Routing_Relation_No" :title="$t('getapi[6766]')" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="PlanQty" :title="$t('getapi[6767]')" align="right" sortable width="90"></vxe-table-column>
            
            <vxe-table-column show-overflow-tooltip field="PriorDate" :title="$t('getapi[135]')" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="Shipment_Cycle" :title="$t('getapi[1409]')" align="right" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="onHandQty" :title="$t('getapi[2234]')" align="right" sortable width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="Iss_VenderReason_Flag" :title="$t('getapi[6768]')" align="right" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="iss_part_code" :title="$t('getapi[8033]')" align="right" sortable width="130"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="iss_part_version" :title="$t('getapi[1300]')" align="right" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="listpart_qty" :title="$t('getapi[4287]')" align="right" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="sum_qty" :title="$t('getapi[4288]')" align="right" sortable width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="qty_on_hand" :title="$t('getapi[8034]')" align="right" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="assist_qty_on_hand" :title="$t('getapi[8035]')" align="right" sortable width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip fixed="right" :title="$t('getapi[6048]')" width="100">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="LookDetail(scope.row)" type="text" size="mini">{{$t('getapi[6769]')}}</el-button>
                </template>
            </vxe-table-column>
        </vxe-table>-->
        </div>
       <!-- <el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
            </el-col>
        </el-row>-->
        <serce :isVisible="isVisible" queryData="ProToIssOrderPlanViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- 改变表格顺序 -->
        <ctable :isVisible="false" title="$t('getapi[1042]')" queryData="ProToIssOrderPlanViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="popVisible" :title="$t('getapi[6770]')" width="70%" :close-on-click-modal="false">
        <el-button @click.native.prevent="expss"  size="mini">{{$t('getapi[922]')}}</el-button>
        <el-table
        header-row-class-name="headerclass"
        stripe
        :data="DdataSet"
        v-loading="loading"
        border
        size="mini"
        :highlight-current-row="true"
        style="width: 100%;"
        >
        <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[574]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="货位" :label="$t('getapi[1957]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="批号" :label="$t('getapi[1763]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="序列号" :label="$t('getapi[1764]')"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[888]')"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="库存状态" :label="$t('getapi[]')"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="single_qty" :label="$t('getapi[4287]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="sum_qty" :label="$t('getapi[4288]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[2234]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="assist_qty_on_hand" :label="$t('getapi[2389]')" align="right"></el-table-column>

        </el-table>
        <el-row>
        <br/>
        <el-col :span="12">
        <span>{{$t('getapi[201]')}}{{DdataSet.length}}{{$t('getapi[6771]')}}</span>
        </el-col>
        <!-- <el-col :span="12">
        <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
        </el-col> -->
        </el-row>

        <br/>
        <br/>

        </el-dialog>
        <!-- 供应商弹窗 -->
        <selector :isVisible="supplierVisible" :isSplitPage=true :selectType="4" :postUrl="'/Basic/Popup/GetSupplyPopuDataList'" @callback="getSupplier" ref="supplier"></selector>
    </div>
    
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'wxplantrans',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                supplierVisible:false,
                dataSet: [], // 主表数据
                DdataSet:[],//弹框表数据
                isVisible: false, // 查询列表是否显示
                popVisible:false,//弹框显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                DbTbNames2:'',//弹框
                pageIndex: 1, // 当前页
                pageSize: 100000, // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                selectData: [],
                TempRow:{},
                dataSetindex:-1,
                btn:{
                    endIssue: false
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        /*create: function(){
            let that = this
            window.addEventListener('storage', event=>{
                if(event.Key === 'lang'){
                    that.colsort();
                }
            })
        },*/
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('ProToIssOrderPlanViewInfo',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1042]"),this.$t("getapi[13]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                if(!this.$limits.menuvisible("plv2", 130, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 484, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    //只读权
                    if (that.$limits.ReadOnlyRightsView('plv2', 130, 1, that.total)) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    //操作权限-查询级别
                    var limits = that.$limits.OperationAuthorityView('plv2', 130, 1, that.total);
                    // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                    switch (limits) {
                        case -1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                            break;
                        case 1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case -2:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                            break;
                        case 2:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case -3:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                            break;
                        case 3:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        default:
                            break;
                    }
                }
                that.btnauthority();
            },
            btnauthority(){
                let that = this
                that.btn.endIssue = false
                if(that.selectData.length > 0){
                    that.btn.endIssue = true
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProToIssOrderPlanViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/ISS/Order/ProToIssOrderPlanViewList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.DataContent.length;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            //
            LookDetail(data){
                let that = this;
                that.TempRow = data;
                that.popVisible = true;
                let param = {
                Routing_Relation_No: data.Routing_Relation_No,
                vender_code: data.Vender_Code,
                so_code: data.so_code,
                qty: data.PlanQty
                }
                that.$http.urlpost('/ISS/Order/PIssMaterialList', param, function(res) {
                    if (res.Success == 1) {
                        that.DdataSet = res.DataContent;
                        that.DbTbNames2 = res.DbTbNames;
                    }
                });

            },
            tableRowClassName({ row, rowIndex }) {
                row.index = rowIndex;
            },
            // 选择供应商
            selectSupplier(scope) {
                let that = this
                that.dataSetindex = scope.rowIndex;
                console.log('行' + that.dataSetindex)
                that.supplierVisible = true;
                //查询子参数
                let param = {
                    "Routing_Relation_No": scope.row.Routing_Relation_No,
                    "part_ID": scope.row.Part_ID,
                    "PRouting_Start_ID": scope.row.IssRoutingID,
                    "vender_code": scope.row.Vender_Code
                }
                that.$refs.supplier.clearInput(true,param);
            },
            getSupplier(data) {
                 let that = this
                 that.dataSet[that.dataSetindex].Vender_Code = data.vender_code;
                 that.dataSet[that.dataSetindex].IssQuotationNum = data.num;
                console.log("测试："+that.dataSet[that.dataSetindex].Vender_Code)
                 if(!that.$limits.fnIsEmpty(that.dataSet[that.dataSetindex].Vender_Code)){
                    let parm = {
                        so_code: that.dataSet[that.dataSetindex].so_code,
                        vender_code: that.dataSet[that.dataSetindex].Vender_Code,
                        part_code: that.dataSet[that.dataSetindex].part_code,
                        part_version: that.dataSet[that.dataSetindex].part_version,
                    };
                    that.loading = true;
                    that.$http.urlpost('/ISS/Order/ProToIssOrderPlanViewByCenderCode', parm, function(res) {
                        that.loading = false;
                        if (res.Success == 1) {
                            if(res.DataContent!=null){
                                if(res.DataContent.length>0){
                                    that.dataSet[that.dataSetindex].listpart_qty = res.DataContent[0].listpart_qty;
                                    that.dataSet[that.dataSetindex].sum_qty = res.DataContent[0].sum_qty;
                                    that.dataSet[that.dataSetindex].qty_on_hand = res.DataContent[0].qty_on_hand;
                                    that.dataSet[that.dataSetindex].assist_qty_on_hand = res.DataContent[0].assist_qty_on_hand;
                                    // that.dataSet[that.dataSetindex].listpart_qty = res.DataContent[0].listpart_qty;
                                }
                            }
                            
                        }
                    });
                }
            },

            //跳转页面
            CreateOrder(){
                let that = this;
                if(that.selectData.length==0)return;
                let tmpvc = that.selectData[0].Vender_Code;
                for(let i=1;i<that.selectData.length;i++){
                    if(tmpvc!=that.selectData[i].Vender_Code){
                        that.$message.warning(that.$t('getapi[8840]'));//'所选行的供应商不是同一个供应商!'
                        return;
                    }
                }
                that.$store.commit('setSharedParams', that.selectData);
                let item = {
                    label: '外协订单管理',
                    name: 'wxorder',
                    path: '/wxorder/create',
                    url: '/wxorder/create',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/wxorder/create'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
               that.loading = true;
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/Order/ProToIssOrderPlanViewExportToExecl', parm, function(res) {
                     that.loading = false;
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProToIssOrderPlanViewInfo",
                    fromname: that.$t('getapi[1042]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            expss() {
                let that = this;
                let parm = {
                Routing_Relation_No: that.TempRow.Routing_Relation_No,
                vender_code: that.TempRow.Vender_Code,
                so_code: that.TempRow.so_code,
                qty: that.TempRow.Plan_Finish_qty
                }
                that.$http.urlpost('/ISS/Order/PIssMaterialExportToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        that.popVisible = false;
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChangeAll({ records }){
                let that = this
                this.selectData = records;
                that.btnauthority()
            },
            handleSelectionChange({checked, records }){
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            endIssue(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        so_code: that.selectData[i].so_code,
                        part_id: that.selectData[i].part_id
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SO/SOMaterilEndIssue', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            sortChange(column){
                let that = this
                let name = column.property
                console.log(column)
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataSet.indexOf(obj1) - that.dataSet.indexOf(obj2);
                        }
                    }
                    that.dataSet.sort(compare);
                    that.dataSet = [...that.dataSet]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataSet.indexOf(obj2) - that.dataSet.indexOf(obj1);
                        }
                    }
                    that.dataSet.sort(compare);
                    that.dataSet = [...that.dataSet]
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separ ate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
